import React from 'react';
import {MapPin, MailIcon, Phone} from 'lucide-react';
import {ReactComponent as Messenger} from '../assets/images/icons/messenger.svg';
import {ReactComponent as Discord} from "../assets/images/icons/discord.svg";
import {ReactComponent as Facebook} from "../assets/images/icons/facebook.svg";
import {ReactComponent as Instagram} from "../assets/images/icons/instagram.svg";
import {ReactComponent as Youtube} from "../assets/images/icons/youtube.svg";
import {ReactComponent as Tiktok} from "../assets/images/icons/tiktok.svg";
import {ReactComponent as Linkedin} from "../assets/images/icons/linkedin.svg";
import {ReactComponent as Twitterx} from "../assets/images/icons/twitterx.svg";
import {ReactComponent as Telegram} from "../assets/images/icons/telegram.svg";
import Logo from "../assets/images/logo.svg";
import {Heading} from "@/components/ui/heading";
import {Link} from "react-router-dom";
import {ReactComponent as AppStore} from "../assets/images/icons/app-store.svg";
import {ReactComponent as GooglePlay} from "../assets/images/icons/google-play.svg";
import Paths from "../constants/Paths";
import MapSection from "@/components/mapSection";
import SocialItemsContainer from "@/components/socialItemsContainer";

const Footer = () => {

    return (
        <>
            <MapSection/>
            <div id="footer-section" className="dark-bg-with-gradients" style={{paddingTop: '35px'}}>
                <div className="generic-container">
                    <div className="grid grid-cols-1 gap-8 xs:grid-cols-2 lg:grid-cols-4">
                        <div className="flex flex-col items-start xs:col-span-2">
                            <img src={Logo} alt="Locked Trade" className="mb-4" style={{ maxWidth: '160px' }}/>
                            <div className="flex items-center mb-4 text-white">
                                <MapPin className="mr-2"/>
                                <div>
                                    <p>Locked Trade LLC</p>
                                    <p>New York Office</p>
                                    <p>40 Wall St. 28th Floor</p>
                                    <p>New York City, NY 10005</p>
                                    {/*
                                    <p>---</p>
                                    <p>Warsaw Office</p>
                                    <p>FlixCash</p>
                                    <p>Chmielna 73 B suite 14</p>
                                    <p>00-801 Warszawa</p>
                                    */}
                                </div>
                            </div>
                            <Link to="mailto:office@lockedtrade.com"
                                  className="flex items-center mb-4 footer-link-item">
                                <MailIcon className="mr-2"/>
                                <p>office@lockedtrade.com</p>
                            </Link>
                            {/*
                            <Link to="tel:+16467848259" className="flex items-center mb-4 footer-link-item">
                                <Phone className="mr-2"/>
                                <p className="text-nowrap">+1 646 784 8259</p>
                            </Link>
                            */}

                            <SocialItemsContainer />

                            <div className="grid grid-cols-2 sm:grid-cols-3 gap-5 mt-2" style={{display: 'none'}}>
                                {/*
                                <Link to="" className="social-item">
                                    <div className="social-icon-container">
                                        <Messenger alt="messenger" />
                                    </div>
                                    <p>Kontakt</p>
                                </Link>
                                */}
                                <Link to={Paths.DISCORD} className="social-item">
                                    <div className="social-icon-container">
                                        <Discord alt="discord"/>
                                    </div>
                                    <p>Discord</p>
                                </Link>
                                {/*
                                <Link to={Paths.FACEBOOK} className="social-item">
                                    <div className="social-icon-container">
                                        <Facebook alt="facebook"/>
                                    </div>
                                    <p>Facebook</p>
                                </Link>
                                */}
                                <Link to={Paths.INSTAGRAM} target="_blank" className="social-item">
                                    <div className="social-icon-container">
                                        <Instagram alt="instagram"/>
                                    </div>
                                    <p>Instagram</p>
                                </Link>
                                {/*
                                <Link to={Paths.YOUTUBE} target="_blank" className="social-item">
                                    <div className="social-icon-container">
                                        <Youtube alt="youtube"/>
                                    </div>
                                    <p>YouTube</p>
                                </Link>
                                */}
                                <Link to={Paths.TIKTOK_NY} className="social-item">
                                    <div className="social-icon-container">
                                        <Tiktok alt="TikTok New York"/>
                                    </div>
                                    <p>TikTok New York</p>
                                </Link>
                                <Link to={Paths.TIKTOK_L} className="social-item">
                                    <div className="social-icon-container">
                                        <Tiktok alt="TikTok London"/>
                                    </div>
                                    <p>TikTok London</p>
                                </Link>
                                <Link to="" className="social-item">
                                    <div className="social-icon-container">
                                        <Twitterx alt="x"/>
                                    </div>
                                    <p>X</p>
                                </Link>
                                {/*
                                <Link to="" className="social-item">
                                    <div className="social-icon-container">
                                        <Linkedin alt="linkedin" />
                                    </div>
                                    <p>Locked Trade</p>
                                </Link>

                                <Link to="" className="social-item">
                                    <div className="social-icon-container">
                                        <Telegram alt="telegram" />
                                    </div>
                                    <p>Locked Trade</p>
                                </Link>
                                */}
                            </div>
                        </div>
                        <div className="flex flex-col items-start" style={{paddingTop: '5px'}}>
                            <Heading level={3} className="text-white"
                                     style={{fontSize: '1.5rem', fontWeight: '600'}}>Menu</Heading>
                            <div className="flex flex-col gap-1 mt-5">
                                <Link to={Paths.HOME} className="footer-link-item">Home</Link>
                                <Link to={Paths.TRAINING} className="footer-link-item">Training</Link>
                                <Link to={Paths.ABOUT} className="footer-link-item">About Us</Link>
                                <Link to={Paths.VIRTUAL_ASSISTANT} className="footer-link-item">AI Assistant</Link>
                                <Link to={Paths.AFFILIATE_PROGRAM} className="footer-link-item">Affiliate
                                    Program</Link>
                                <Link to={Paths.SUPPORT} className={`footer-link-item`}>Support</Link>
                            </div>
                            <p className="text-white text-sm mt-8" style={{display: 'none'}}>
                                Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nam dignissim tellus et
                                nisi
                                ultricies consectetur. Nulla placerat at mi vitae pretium. Nulla facilisi.
                            </p>
                        </div>
                        <div className="flex flex-col items-start" style={{paddingTop: '5px'}}>
                            <Heading level={3} className="text-white"
                                     style={{fontSize: '1.5rem', fontWeight: '600'}}>Regulations</Heading>
                            <div className="flex flex-col gap-1 mt-5">
                                <Link to={Paths.AFFILIATE_PROGRAM_REGULATIONS} className="footer-link-item">Affiliate
                                    Program Regulations</Link>
                                <Link to={Paths.PRIVACY_POLICY} className="footer-link-item">Privacy Policy</Link>
                                <Link to={Paths.TERMS_OF_SERVICE} className="footer-link-item">Terms of
                                    Service</Link>
                                <Link to={Paths.SERVICE_PROVISION_REGULATIONS} className="footer-link-item">Service
                                    Provision Regulations</Link>
                                <Link to={Paths.RETURN_POLICY} className="footer-link-item">Return Policy</Link>
                            </div>
                        </div>
                    </div>
                    <div style={{display: 'none'}}>
                        <div className="store-buttons-container">
                            <a href="https://apps.apple.com" target="_blank" rel="noopener noreferrer">
                                <AppStore alt="Download on the App Store"/>
                            </a>
                            <a href="https://play.google.com" target="_blank" rel="noopener noreferrer">
                                <GooglePlay alt="Get it on Google Play"/>
                            </a>
                        </div>
                    </div>
                    <div className={`pt-4`}>
                    </div>
                    <div className="border-top-blue-color footer-copyright-container">
                        <p>Trading is risky and most days traders lose money. All content should be considered
                            hypothetical, selected after the fact, to demonstrate our services and should not be
                            construed as financial advice. Decisions to buy, sell, hold or trade securities, commodities
                            and other investments involve risk and are best made with the advice of qualified financial
                            professionals. Past results do not guarantee future results.</p>
                        <p>The risk of loss in trading can be significant. You should therefore carefully consider
                            whether such trading is suitable for you in light of your financial situation.</p>
                        <p>Hypothetical or simulated performance results have certain limitations, unlike an actual
                            performance record, simulated results do not reflect actual trading. In addition, because
                            the trades have not been executed, results may be under- or over-compensated by the impact,
                            if any, of certain market factors, such as illiquidity. Simulated trading programs are also
                            generally subject to the fact that they are designed with the benefit of hindsight. No
                            representation is made that any account will achieve or is likely to achieve profits or
                            losses similar to those shown.</p>
                        <p>The opinions posted on this website may not be representative of other clients and are not a
                            guarantee of future results or success. Any trading results presented in the opinions are
                            not verified and we have no reason to believe that individual experiences presented are
                            typical, given that results will vary depending on many factors, such as skill, risk
                            management, experience and the fact that trading itself is a very risky activity where it is
                            easy to lose money.</p>
                        <p>As a provider of technical analysis tools for charting platforms, we do not have access to
                            our clients’ personal trading accounts or brokerage statements. As a result, we have no
                            reason to believe that our clients are doing better or worse than traders as a whole based
                            on any content or tools we provide.</p>
                        <p>This is not our full disclaimer. Please read our full <Link to={Paths.TERMS_OF_SERVICE} className={`text-white`} style={{ textDecoration: 'underline' }}>Terms
                            of Service</Link>.</p>
                        <p className="footer-copyright-paragraph">© 2025 Locked Trade LLC. All rights reserved.</p>
                    </div>
                </div>
            </div>
        </>
    );
};

export default Footer;